/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormCustom } from '../../models/form-custom';

export interface FindOrCreateFormCustom$Params {
  formId: string;
}

export function findOrCreateFormCustom(
  http: HttpClient,
  rootUrl: string,
  params: FindOrCreateFormCustom$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<FormCustom>> {
  const rb = new RequestBuilder(rootUrl, findOrCreateFormCustom.PATH, 'put');
  if (params) {
    rb.path('formId', params.formId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FormCustom>;
    })
  );
}

findOrCreateFormCustom.PATH = '/forms/{formId}/custom';
